import * as PropTypes from 'prop-types';
import { ptColor } from '../../consts/propTypes.const';
export var TextPropsType = {
  align: PropTypes.string,
  bold: PropTypes.bool,
  children: PropTypes.node,
  color: ptColor,
  'data-id': PropTypes.string,
  inline: PropTypes.bool,
  italic: PropTypes.bool,
  overflow: PropTypes.oneOf(['normal', 'breakWord']),
  size: PropTypes.string,
  truncate: PropTypes.bool,
  lines: PropTypes.number,
  fontWeight: PropTypes.oneOf(['regular', 'bold', 'medium', 400, 600, 700]),
  markdown: PropTypes.bool,
  markdownLinkMutator: PropTypes.func
};
export var TextDisplayName = 'text';
export var TextDefaultProps = {
  'data-id': TextDisplayName,
  overflow: 'normal',
  size: 'sm',
  color: 'grey'
};